import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1524.40706 L1920,1750.28941 L677.647059,1750.28941 L677.647059,1524.40706 L1920,1524.40706 Z M1920,1072.52941 L1920,1298.52471 L677.647059,1298.52471 L677.647059,1072.52941 L1920,1072.52941 Z M225.882353,169.067765 L225.882353,620.945412 L348.649412,620.945412 L348.649412,398.564235 L790.588235,733.773647 L348.649412,1069.096 L348.649412,846.714824 L0,846.714824 L0,169.067765 L225.882353,169.067765 Z M1242.35294,620.877647 L1242.35294,846.76 L1016.47059,846.76 L1016.47059,620.877647 L1242.35294,620.877647 Z M1581.17647,620.877647 L1581.17647,846.76 L1355.29412,846.76 L1355.29412,620.877647 L1581.17647,620.877647 Z M1920,620.877647 L1920,846.76 L1694.11765,846.76 L1694.11765,620.877647 L1920,620.877647 Z M1920,169 L1920,394.995294 L677.647059,394.995294 L677.647059,169 L1920,169 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveDownSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveDownSolid, _Component);

  var _super = _createSuper(IconMoveDownSolid);

  function IconMoveDownSolid() {
    _classCallCheck(this, IconMoveDownSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveDownSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveDown",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveDownSolid.displayName = "IconMoveDownSolid";
  return IconMoveDownSolid;
}(Component);

IconMoveDownSolid.glyphName = 'move-down';
IconMoveDownSolid.variant = 'Solid';
IconMoveDownSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveDownSolid;
export { IconMoveDownSolid };